import React from 'react';

interface LogoProps {
  variant?: 'full' | 'icon';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  variant = 'full', 
  size = 'md', 
  className = ''
}) => {
  const sizes = {
    sm: { height: '24px' },
    md: { height: '32px' },
    lg: { height: '40px' },
    xl: { height: '48px' },
  };

  const { height } = sizes[size];

  if (variant === 'icon') {
    return (
      <img 
        src="/favicon.png" 
        alt="GaadiMatic" 
        className={className}
        style={{ height }} 
      />
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img 
        src="/gaadimatic-logo.png" 
        alt="GaadiMatic" 
        style={{ height }} 
      />
    </div>
  );
};

export default Logo;
